import React from 'react'
import moment from 'moment'
import { Box, Text, Display, FlexDirection } from '@gousto-internal/citrus-react'
import { formatDeliveryTime } from '../../../utils/formatters'
import { DeliveryDetailCard } from './DeliveryDetailCard'

type DeliveryDetailsProps = {
  deliverySlot: {
    date: string
    timeStart: string
    timeEnd: string
  }
  deliveryAddress: {
    name?: string
    line1: string
    line2?: string
    line3?: string
    town: string
    postcode: string
  }
}

const getAddressLines = (deliveryAddress: DeliveryDetailsProps['deliveryAddress']) =>
  [
    deliveryAddress.line1,
    deliveryAddress.line2,
    deliveryAddress.line3,
    deliveryAddress.town,
    deliveryAddress.postcode,
  ].filter(Boolean)

export const DeliveryDetails = ({ deliverySlot, deliveryAddress }: DeliveryDetailsProps) => {
  const addressLines = getAddressLines(deliveryAddress)
  const fullAddress = addressLines.join(', ')

  return (
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Row}
      width="100%"
      gap={3}
      data-testid="delivery-details"
    >
      <DeliveryDetailCard iconName="calendar" title="Date">
        <Text size={2}>{moment(deliverySlot.date).format('dddd Do MMM')}</Text>
        <Text size={2}>
          {formatDeliveryTime(deliverySlot.timeStart)} - {formatDeliveryTime(deliverySlot.timeEnd)}
        </Text>
      </DeliveryDetailCard>

      <DeliveryDetailCard iconName="local_shipping" title="Address">
        {deliveryAddress.name && <Text size={2}>{deliveryAddress.name}</Text>}
        <Text
          size={2}
          aria-label={fullAddress}
          title={fullAddress}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {fullAddress}
        </Text>
      </DeliveryDetailCard>
    </Box>
  )
}
